module.exports = __webpack_public_path__ + "img/icon-plus-white.d733ae58.svg";